import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
export const routes = [
    {
        path: "/",
        component: () => import("@/views/Main"),
        redirect: "/home",
        children: [
            {
                path: "/home",
                name: "home",
                component: () => import("@/views/home/Home1"),
            },
            {
                path: "/mine",
                name: "mine",
                component: () => import("@/views/mine/Mine"),
            },
        ],
    },
    {
        path: "/hotelList",
        component: () => import("@/views/home/HotelList"),
        name: "hotelList",
    },
    {
        path: "/hotelDetail",
        component: () => import("@/views/home/HotelDetail"),
        name: "hotelDetail",
    },
    {
        path: "/confirmOrder",
        component: () => import("@/views/home/ConfirmOrder"),
        name: "confirmOrder",
    },
    {
        path: "/submitSuccess",
        component: () => import("@/views/home/SubmitSuccess"),
        name: "submitSuccess",
    },
    {
        path: "/collection",
        component: () => import("@/views/mine/Collection"),
        name: "collection",
    },
    {
        path: "/orderList",
        component: () => import("@/views/mine/OrderList"),
        name: "orderList",
    },
    {
        path: "/orderDetail",
        component: () => import("@/views/mine/OrderDetail"),
        name: "orderDetail",
    },
    {
        path: "/testLogin",
        component: () => import("@/views/login/TestLogin"),
        name: "testLogin",
    },
    {
        path: "/noPermission",
        name: "NoPermission",
        component: () => import("@/views/NoPermission"),
    },
    {
        path: "*",
        name: "NotFound",
        component: () => import("@/views/404"),
    },

    //路由独享守卫
    // {
    //     beforeEnter: (to, from, next) => {
    //         // ...
    //     }
    // }
];

const router = new VueRouter({
    mode: "hash",
    routes,
});
//全局前置守卫
// router.beforeEach((to, from, next) => {})
//全局解析守卫
// router.beforeResolve((to, from, next) => {})
//全局后置守卫
// router.afterEach((to, from, next) => {})

//组件内守卫
// const Foo = {
//     template: `...`,
//     beforeRouteEnter(to, from, next) {
//         // 在渲染该组件的对应路由被 confirm 前调用
//         // 不！能！获取组件实例 `this`
//         // 因为当守卫执行前，组件实例还没被创建
//     },
//     beforeRouteUpdate(to, from, next) {
//         // 在当前路由改变，但是该组件被复用时调用
//         // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
//         // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
//         // 可以访问组件实例 `this`
//     },
//     beforeRouteLeave(to, from, next) {
//         // 导航离开该组件的对应路由时调用
//         // 可以访问组件实例 `this`
//     },
// };
export default router;
